import React from 'react'
import t from 'prop-types'

import {Pagina} from 'ibook-api'
import Camino from './camino'
import { 
    PantallaLibro,
    Pizarra,
    TextosUsuario,
    BotonHerramientasContainer,
    BarraHerramientasContainer,
    MascarasContainer,
    CartulinaContainer,
    PersianaContainer,
    CronoContainer,
    Util
} from 'ibook-api'

const PANTALLA_LIBRO_CAMINOS_ABIERTOS_KEY = 'pantalla-libro-sesion-estado'
const getEstadoSesion = () => JSON.parse(Util.sessionStorage.getItem(PANTALLA_LIBRO_CAMINOS_ABIERTOS_KEY) || '{}')
const guardarEstadoEnSesion = (estado) => Util.sessionStorage.setItem(PANTALLA_LIBRO_CAMINOS_ABIERTOS_KEY, JSON.stringify(estado))

class PantallaLibroDosPaginas extends React.Component {
    constructor(props) {
        super(props)

        const estadoSesion = getEstadoSesion()
        const { caminoPaginaIzquierdaAbierto, caminoPaginaDerechaAbierto } = estadoSesion
        
        this.state = {
            caminoPaginaIzquierdaAbierto,
            caminoPaginaDerechaAbierto
        }
    }

    componentDidUpdate(prevProps) {
        const { libroId, numPagina, caminoPaginaIzquierda, caminoPaginaDerecha } = this.props
        const { caminoPaginaIzquierdaAbierto, caminoPaginaDerechaAbierto } = this.state
        if (prevProps.libroId !== libroId || prevProps.numPagina !== numPagina ) {
            const caminoPaginaIzquierda_antiguo = prevProps.caminoPaginaIzquierda.numPagina
            const caminoPaginaIzquierda_nuevo = caminoPaginaIzquierda.numPagina
            const caminoPaginaDerecha_antiguo = prevProps.caminoPaginaDerecha.numPagina
            const caminoPaginaDerecha_nuevo = caminoPaginaDerecha.numPagina
            /*
            if (caminoPaginaIzquierdaAbierto) {
                this.setState({ caminoPaginaIzquierdaAbierto: true })
            }
            if (caminoPaginaDerechaAbierto) {
                this.setState({ caminoPaginaDerechaAbierto: true })
            }
            */
           if(!window.modoTrabajo){
                this.setState({ caminoPaginaIzquierdaAbierto: false })
                this.setState({ caminoPaginaDerechaAbierto: false })
           }
           /*misma posición de camino*/
            if (caminoPaginaIzquierdaAbierto && caminoPaginaIzquierda_antiguo===caminoPaginaIzquierda_nuevo) {
                this.setState({ caminoPaginaIzquierdaAbierto: true })
            }
            if (caminoPaginaDerechaAbierto && caminoPaginaDerecha_antiguo===caminoPaginaDerecha_nuevo) {
                this.setState({ caminoPaginaDerechaAbierto: true })
            }
            /*posiciones entrecruzadas*/
            if (caminoPaginaIzquierdaAbierto && caminoPaginaIzquierda_antiguo===caminoPaginaDerecha_nuevo) {
                this.setState({ caminoPaginaDerechaAbierto: true })
            }
            if (caminoPaginaDerechaAbierto && caminoPaginaDerecha_antiguo===caminoPaginaIzquierda_nuevo) {
                this.setState({ caminoPaginaIzquierdaAbierto: true })
            }
        }
    }

    handleAlternarCaminoIzquierda = () => {
        const { caminoPaginaIzquierdaAbierto } = this.state
        this.setState( {caminoPaginaIzquierdaAbierto: !caminoPaginaIzquierdaAbierto} )
    }

    handleAlternarCaminoDerecha = () => {
        const { caminoPaginaDerechaAbierto } = this.state
        this.setState( {caminoPaginaDerechaAbierto: !caminoPaginaDerechaAbierto} )
    }

    cerrarCaminos() {
        this.setState({ caminoPaginaIzquierdaAbierto: false })
        this.setState({ caminoPaginaDerechaAbierto: false })
        if(window.modoTrabajo){
            const { caminoPaginaIzquierdaAbierto, caminoPaginaDerechaAbierto } = this.state
            if (caminoPaginaIzquierdaAbierto) {
                this.setState({ caminoPaginaIzquierdaAbierto: true })
            }
            if (caminoPaginaDerechaAbierto) {
                this.setState({ caminoPaginaDerechaAbierto: true })
            }
        }
}

    handleIrAPaginaAnterior = () => {
        const { numPaginaIzquierda, numPrimeraPagina, onPagina } = this.props
        const numPagina = Math.max(numPaginaIzquierda - 1, numPrimeraPagina)
        this.cerrarCaminos()
        onPagina(numPagina)
    }

    handleIrAPaginaSiguiente = () => {
        const { numPaginaDerecha, numUltimaPagina, onPagina } = this.props
        const numPagina = Math.min(numPaginaDerecha + 1, numUltimaPagina )
        this.cerrarCaminos()
        onPagina(numPagina)
    }

    handleZona = (libroId, numPagina, numZona) => {
        guardarEstadoEnSesion(this.state)
        this.props.onZona(libroId, numPagina, numZona)
    }

    handleIndice = (libroId) => {
        this.setState({
            caminoPaginaIzquierdaAbierto: false,
            caminoPaginaDerechaAbierto: false
        }, () => {
            guardarEstadoEnSesion(this.state)
            this.props.onIndice(libroId)    
        })
    }

    renderTextosUsuarioPaginaIzquierda = () => {
        const { libroId, numPaginaIzquierda, configTextosUsuario, 
            textosUsuarioPaginaIzquierda, modoCrearTextoUsuario, 
            onCrearTextoUsuario, onActualizarTextoUsuario } = this.props
        return (
            <TextosUsuario.PanelTextos 
                tamFuenteBase={ 20 }
                // tamFuenteBase={ this.state.tamFuenteBase }
                textos={ textosUsuarioPaginaIzquierda }  
                config = { configTextosUsuario } 
                modoCrear={ modoCrearTextoUsuario }
                onCrear = { 
                    (modoCrear, x, y, textoHtml) => {
                        onCrearTextoUsuario(
                            modoCrear, x, y, textoHtml, libroId, numPaginaIzquierda
                        )
                    }
                }
                onActualizar={ onActualizarTextoUsuario }

                minX={ 1 }
                maxX={ 195 }
            />                
        )
    }

    renderTextosUsuarioPaginaDerecha = () => {
        const { libroId, numPaginaDerecha, configTextosUsuario, 
            textosUsuarioPaginaDerecha, modoCrearTextoUsuario, 
            onCrearTextoUsuario, onActualizarTextoUsuario } = this.props

        return (
            <TextosUsuario.PanelTextos 
                tamFuenteBase={ 20 }
                // tamFuenteBase={ this.state.tamFuenteBase }
                textos={ textosUsuarioPaginaDerecha }   
                config = { configTextosUsuario }
                modoCrear={ modoCrearTextoUsuario }
                onCrear={ 
                    (modoCrear, x, y, textoHtml) => {
                        onCrearTextoUsuario(
                            modoCrear, x, y, textoHtml, libroId, numPaginaDerecha
                        )
                    }
                }
                onActualizar={ onActualizarTextoUsuario }

                minX={ -99 }
                maxX={ 95 }
            />
        )
    }
    
    crearDivBotonLibro(libro, libroId){
        return <PantallaLibro.BotonLibro libroId={libro} seleccionado={ libroId === libro } onIndice={ () => this.handleIndice(libro) } />
    }

    handleIrAPaginaDesdePaginador = (numPagina) => {
        const { onPagina } = this.props;
        this.cerrarCaminos();
        onPagina(numPagina);
    }

    render () {
        const { 
            libroId, numPagina, dimensionesBaja, multiplicadorBaja, configBotones, 
            // configIndice,
            numPaginaIzquierda, caminoPaginaIzquierda, zonasPaginaIzquierda,
            numPaginaDerecha, caminoPaginaDerecha, zonasPaginaDerecha,   
            numPrimeraPagina, numUltimaPagina,
            textosUsuarioVisible, imagenUsuarioVisible,          
            Paginacion, listaNavegacionLibros, infoCaminos,
            onNotas
        } = this.props

        const { caminoPaginaIzquierdaAbierto, caminoPaginaDerechaAbierto } = this.state

        const resolucion = {
            w: dimensionesBaja.w * 2,
            h: dimensionesBaja.h
        }

        const arrayListaNavegacionLibros = listaNavegacionLibros.libros.split(',')
        const divListaNavegacionLibros = <div className="botonesLibros">
                { arrayListaNavegacionLibros.map(libro => this.crearDivBotonLibro(libro, libroId)) }
            </div>
        const divListaNavegacionLibros_izquierda = listaNavegacionLibros.posicion==='izquierda' ? divListaNavegacionLibros : ''
        const divListaNavegacionLibros_centro = listaNavegacionLibros.posicion==='centro' ? divListaNavegacionLibros : ''
        const divListaNavegacionLibros_derecha = listaNavegacionLibros.posicion==='derecha' ? divListaNavegacionLibros : ''
        // const libro_zonaAyudaCaminos = infoCaminos.zonaAyudaCaminos.substr(0,2) || "SB"
        const zonaAyudaCaminos = infoCaminos.zonaAyudaCaminos
        const libro_zonaAyudaCaminos = zonaAyudaCaminos ? zonaAyudaCaminos.substr(0,2) : "SB"
        const pagina_zonaAyudaCaminos = zonaAyudaCaminos ? parseInt(zonaAyudaCaminos.substr(2,3),10) : 501
        const zona_zonaAyudaCaminos = zonaAyudaCaminos ? parseInt(zonaAyudaCaminos.split('.')[1],10) : 1

        return (
            <div className={`contenedor libro${libroId}`}>    
                { caminoPaginaIzquierda && <div className="botonAyudaCamino" onClick={ () => this.handleZona(libro_zonaAyudaCaminos, pagina_zonaAyudaCaminos, zona_zonaAyudaCaminos) } >?</div> }
                { caminoPaginaIzquierda && <PantallaLibro.BotonCaja 
                    id="botonCajaIzquierda" 
                    activa={ caminoPaginaIzquierdaAbierto } 
                    onAlternar={ this.handleAlternarCaminoIzquierda } 
                /> }
                { caminoPaginaIzquierda && <Camino id="Izquierda" abierta={ caminoPaginaIzquierdaAbierto } camino={ caminoPaginaIzquierda } onHito={ this.handleZona } /> }
                { caminoPaginaDerecha && <PantallaLibro.BotonCaja 
                    id="botonCajaDerecha" 
                    activa={ !caminoPaginaDerechaAbierto } 
                    onAlternar={ this.handleAlternarCaminoDerecha } 
                /> }
                { caminoPaginaDerecha && <Camino id="Derecha" abierta={ caminoPaginaDerechaAbierto } camino={ caminoPaginaDerecha } onHito={ this.handleZona } /> }
                <PantallaLibro.SeccionSuperior />
                <div className='contenedorIbook'>
                    <div class="marcoAmpliacion">
                        <div className={`botonPasoPaginaI${ numPaginaIzquierda <= numPrimeraPagina ? ' desactivado' : ''}`} onClick={ this.handleIrAPaginaAnterior } />
                        <div class="factorAmpliacion"> 
                            <div className="marcoPaginas dosPaginas">
                            { <div className='notas' onClick={ () => onNotas() }></div>  }
                            <Pagina libroId={libroId} numPagina={numPaginaIzquierda} zonas={zonasPaginaIzquierda} multiplicadorBaja={multiplicadorBaja} dimensionesBaja={dimensionesBaja} configBotones={configBotones} onZona={ this.handleZona } >
                                { textosUsuarioVisible && this.renderTextosUsuarioPaginaIzquierda() }
                            </Pagina>
                            <Pagina libroId={libroId} numPagina={numPaginaDerecha} zonas={zonasPaginaDerecha} multiplicadorBaja={multiplicadorBaja} dimensionesBaja={dimensionesBaja} configBotones={configBotones} onZona={ this.handleZona } >
                                { textosUsuarioVisible && this.renderTextosUsuarioPaginaDerecha() }
                            </Pagina>
                            <Pizarra visible={ imagenUsuarioVisible } resolucion={ resolucion } />
                            <MascarasContainer />
                            <CartulinaContainer />
                            <PersianaContainer />
                        </div>
                        </div>
                        <div className={`botonPasoPaginaD${ numPaginaDerecha >= numUltimaPagina ? ' desactivado' : ''}`} onClick={ this.handleIrAPaginaSiguiente } />
                    </div>
                </div>
                <PantallaLibro.SeccionInferior>
                    <div className="alineadoIzquierda">
                        <div className="logoBarra"></div>
                        { divListaNavegacionLibros_izquierda }
                    </div>
                    { divListaNavegacionLibros_centro }
                    <Paginacion libroId={ libroId } numPagina={ numPagina } onPagina={ this.handleIrAPaginaDesdePaginador } />
                    <div className="alineadoDerecha">
                        { divListaNavegacionLibros_derecha }
                        <div className="salir" onClick={ () => this.handleIndice(libroId) }></div>
                    </div>
                </PantallaLibro.SeccionInferior>
                <BarraHerramientasContainer />
                <BotonHerramientasContainer />
                <CronoContainer />
            </div>
        )
    }
}

PantallaLibroDosPaginas.propTypes = {
    libroId: t.string.isRequired,
    numPagina: t.number.isRequired,
    numPaginaIzquierda: t.number.isRequired,
    numPaginaDerecha: t.number.isRequired,
    numPrimeraPagina: t.number.isRequired,
    numUltimaPagina: t.number.isRequired,

    Paginacion: t.any, // componente react para paginacion 
    listaNavegacionLibros: t.any,
    infoCaminos: t.any,

    // textosUsuarioTextoAyuda: t.string,
    textosUsuarioVisible: t.bool,
    textosUsuarioPaginaIzquierda: t.array, 
    textosUsuarioPaginaDerecha: t.array,
    modoCrearTextoUsuario: t.bool, 
    configTextosUsuario: t.object.isRequired,
    onCrearTextoUsuario: t.func, 
    onActualizarTextoUsuario: t.func,

    onIndice: t.func,
    onZona: t.func,
    onPagina: t.func,

    dimensionesBaja: t.object, 
    multiplicadorBaja: t.number, 
    configBotones: t.object, 
    configIndice: t.object,

    zonasPaginaIzquierda: t.array,
    caminoPaginaIzquierda: t.array, 
    caminoPaginaDerecha: t.array, 
    zonasPaginaDerecha: t.object,
    imagenUsuarioVisible: t.bool
}

export default PantallaLibroDosPaginas
